import React from "react";
//import logo from './logo.svg';
import "./App.scss";
import { Outlet } from "react-router";
import { UserProvider } from "./Context/useAuth";
import Toast from "./Components/Toast/Toast";
import { OrderProvider } from "./Context/useOrder";
import { InterceptorProvider } from "./Context/useInterceptor";
const APP_VERSION = process.env.REACT_APP_VERSION;

const App = () => {
  return (
    <>
      <UserProvider>
        <InterceptorProvider>
          <OrderProvider>
            <Outlet />
          </OrderProvider>
        </InterceptorProvider>
      </UserProvider>
      <Toast />
      <div id="version" className="d-none">
        {APP_VERSION}
      </div>
    </>
  );
};
export default App;
